// eslint-disable-next-line import/order
import type { ComponentType } from 'react';
import withEvents from '../../controllers/engagement-with-events';
import withMessage from '../../controllers/engagement-with-message';

import ModalDialog from './main';

const ModalDialogWithEvents: ComponentType<any> = withEvents(ModalDialog);

export { ModalDialog, ModalDialogWithEvents };

// eslint-disable-next-line camelcase
const _default_1: ComponentType<any> = withMessage(ModalDialogWithEvents, 'modalDialog');
// eslint-disable-next-line camelcase
export default _default_1;
